import React, { useContext } from 'react';
import { CopyIcon } from '../../Components';
import AppContext from '../../AppContext';
import { copyOrder } from '../../actions/orders';

export const CopyOrderButton = (props) => {
  const context = useContext(AppContext);

  return <CopyIcon onClick={() => copyOrder({ context, id: props.id, onCopy: props.onAction })} />;
};
